__turbopack_context__.v({
  "innerNoOuterScroll": "SidebarGroupedProduct-module-scss-module__9wC3NG__innerNoOuterScroll",
  "root": "SidebarGroupedProduct-module-scss-module__9wC3NG__root",
  "sidebar-container": "SidebarGroupedProduct-module-scss-module__9wC3NG__sidebar-container",
  "sidebar-container-inner": "SidebarGroupedProduct-module-scss-module__9wC3NG__sidebar-container-inner",
  "sidebar-container-inner-wrapper": "SidebarGroupedProduct-module-scss-module__9wC3NG__sidebar-container-inner-wrapper",
  "sidebar-main": "SidebarGroupedProduct-module-scss-module__9wC3NG__sidebar-main",
  "sidebar-overlay": "SidebarGroupedProduct-module-scss-module__9wC3NG__sidebar-overlay",
});
